
import '../../Pages/Client/AO/AODetails.scss';
import '../../Pages/Client/AO/Alertes.scss';

//import { ROLES } from './config';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, createTheme, Dialog, IconButton, Toolbar } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import usePostRequest from '../../hooks/usePostRequest';
import useWindowSize from '../../hooks/useWindowSize';
import {buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
import { TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';
import SelectRadioBtn from '../shared/SelectGender';

{/*mode==ajouter c pour ajouter un collaborateur*/ }
{/*mode==editer c pour editer les roles d'un collaborateur*/ }
function DialogEsnInviteExpert({ open, setOpen, expertId, getAllExperts }) {
    DialogEsnInviteExpert.propTypes = {
        open: PropTypes.any,
        expertId: PropTypes.any,
        getAllExperts: PropTypes.func,
        // rowSelected: PropTypes.any,
        setOpen: PropTypes.func,
        // getMyCollaborators: PropTypes.func,
        // mode: PropTypes.any,
        // title: PropTypes.any,
    };

    const [salarie,setSalarie]=useState('indep');
    const { postData } = usePostRequest();
    const [email, setEmail] = useState('');

    const { device } = useWindowSize();

    // const [roles, setRoles] = useState({ isLittleAdmin: '', isManager: '', isResponsableAchat: '', isRh: '', isComptable: '', });
    const { i18n } = useTranslation();
    // const [isValid] = useFormValidation([
    //     { name: 'nom', value: nom },
    //     { name: 'prenom', value: prenom },
    //     { name: 'email', value: email },
    // ]);

    console.log('expertId', expertId);
    // useEffect(() => {
    //     if (rowSelected) {
    //         console.log('rowSelected hey', rowSelected);
    //         setEmail(rowSelected?.email_);
    //         setNom(rowSelected?.nom);
    //         setPrenom(rowSelected?.prenom);
    //         setTele(rowSelected?.tele);
    //         //console.log('rowselecte', rowSelected);
    //         if(role=='esn')
    //             setRoles({
    //                 isAdmin: roleCollab(rowSelected?.role?.Admin),
    //                 isLittleAdmin: roleCollab(rowSelected?.role?.littleAdmin),
    //                 isCommercial: roleCollab(rowSelected?.role?.Commercial),
    //                 isComptable: roleCollab(rowSelected?.role?.Comptable),
    //             });
    //         else
    //             setRoles({
    //                 isAdmin: roleCollab(rowSelected?.role?.Admin),
    //                 isLittleAdmin: roleCollab(rowSelected?.role?.littleAdmin),
    //                 isManager: roleCollab(rowSelected?.role?.Manager),
    //                 isResponsableAchat: roleCollab(rowSelected?.role?.ResponsableAchat),
    //                 isRh: roleCollab(rowSelected?.role?.Rh),
    //                 isComptable: roleCollab(rowSelected?.role?.Comptable),
    //             });
    //     }
    // }, [rowSelected]);

    const envoyerInvitation = async () => {
        try {
            const response = await postData({
                url: '/expert/inviteExpertToJoin',
                payload: {
                    expertId: expertId,
                    isEsn: true,
                    isSalarie: (salarie == 'indep' ? false : true),
                    isDossierCandidat: true,
                    email: email,
                },
            });
            setOpen(false);
            await getAllExperts();
            console.log('response envoyer inv', response);
        } catch (error) {
            console.log(error);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setEmail('');
        setEmail('');
        // setPrenom('');
        // setTele('');
        // setRoles(role=='client'?{ isLittleAdmin: '', isManager: '', isResponsableAchat: '', isRh: '', isComptable: '', }
        //     :{ isLittleAdmin: '', isCommercial: '', isComptable: '' });
        //setOpen();
        // getMyCollaborators(); //* we can think about doint getMyCollaborators here
    };
    const scroll = 'paper';
    const theme = createTheme({
        overrides: {
            MuiAppBar: {
                root: {
                    borderRadius: '20px', // Set the desired borderRadius value here
                },
            },
        },
    });

    return (
        <Dialog
            fullScreen
            open={open}
            TransitionComponent={Transition}
            onClose={handleClose}
            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <ThemeProvider theme={theme}>
                <AppBar>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', background: '#F5F6FA', paddingTop: '90px', paddingBottom: '24px', paddingLeft: device == 'desktop' ? '24px' : '0px' }}>
                    <div className='frame0FicheCollab'>
                        <h4 className='frame1FicheCollab'>{i18n.t('Envoyer invitation')}</h4>

                        <div className='frame8FicheCollab'>
                            <div className='frame9FicheCollab'>

                                <div className='frame10FicheCollab'>
                                    <p className='frame8DonneeFacturation'>{i18n.t('Veuillez sélectionner le type')}</p>
                                    <SelectRadioBtn
                                        value={salarie}
                                        setValue={setSalarie}
                                        name="genre"
                                        options={[
                                            { label: 'Salarié', optionValue: 'salarie' },
                                            { label: 'Indépendant', optionValue: 'indep' }
                                        ]}
                                    // setCheckUpdateValue={setWasValuesUpdated}
                                    />
                                </div>
                                <div className='frame10FicheCollab'>
                                    <TextFieldComponent
                                        id="outlined-name"
                                        label={i18n.t('Email')}
                                        name='email'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        // disabled={mode == 'ajouter' ? false : true}
                                        style={{ width: '100%', backgroundColor: 'white' }}
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },
                                        }}
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: device == 'desktop' ? 'row' : 'column', gap: '24px', justifyContent: 'flex-end', alignSelf: 'stretch', width: '100%' }}>
                                    {/* <Button
                                            variant='text'
                                            style={{ ...buttonStyles(), ...{ width: device == 'desktop' ? 'auto' : '100%', order: device == 'desktop' ? '0' : '1' } }}
                                            onClick={handleClose}
                                        >
                                            {i18n.t('Annuler')}
                                        </Button> */}
                                    <Button
                                        variant='contained'
                                        style={{ ...buttonStylesBlue(false) }}
                                        onClick={() => {
                                            envoyerInvitation();
                                        }}
                                    >
                                        {i18n.t('Envoyer')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ThemeProvider>
        </Dialog>
    );
}

export default DialogEsnInviteExpert;